export const readLoadedFile = async (file: File) => {
	if (!file) return null;

	const reader = new FileReader();

	reader.readAsText(file);

	const result = await new Promise<string | null | ArrayBuffer>((resolve) => {
		reader.onload = () => {
			resolve(reader.result);
		};
	});

	return result;
};
